import Rule from "../../../common/rule";
import FootballState from "../../state/football-state";
import { isSeriesOvertime } from "../../utils/overtime-utils";

export default class OvertimeDrive extends Rule {
    // eslint-disable-next-line no-unused-vars
    applicable(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        // Series overtime only: with OT Kickoffs on a new possession keeps
        // the ball where the play left it (PSTATS-1268).
        return (
            fragment.associatedState === FootballState.EndOfPlay &&
            isSeriesOvertime(gameContext) &&
            gameContext.getDriveContext().triggerDrive
        );
    }

    // eslint-disable-next-line no-unused-vars
    async apply(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        const { homeTeamHasPossession } = play.getContextSnapshot();
        if (homeTeamHasPossession) {
            gameContext.homeTeamOvertimeDrive = true;
        } else {
            gameContext.awayTeamOvertimeDrive = true;
        }
        ruleContext.setResetField(true);
    }
}
